import { apiClient } from '@shared/utils/api-client';

export interface LoginDto {
  email: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  admin: {
    id: number;
    email: string;
    name: string | null;
    role: 'SUPER_ADMIN' | 'SELLER_ADMIN';
    sellerId: number | null;
  };
}

export interface LogoutResponse {
  message: string;
}

export const authApi = {
  login: async (data: LoginDto): Promise<LoginResponse> => {
    return apiClient.post<LoginResponse>('/auth/login', data);
  },

  logout: async (): Promise<LogoutResponse> => {
    return apiClient.post<LogoutResponse>('/auth/logout');
  },
};

